import styled from "styled-components";
import { type TooltipProps } from "./tooltip";
import { getBackgroundColor, getBodyFillColor, getBorderRadius, getColor } from "./tooltip.styles.utils";
import { createShouldForwardPropBlockList, deepMerge } from "../utils/helper";

type WrapperProps = Pick<TooltipProps, "color" | "keepOpen"> & {
    layoutTheme?: TooltipProps["theme"];
};
type BodyProps = Pick<TooltipProps, "color">;

export const Wrapper = styled("div").withConfig({
    shouldForwardProp: createShouldForwardPropBlockList(["color", "keepOpen", "layoutTheme"]),
})<WrapperProps>(({ color, keepOpen, layoutTheme, theme }) => ({
    pointerEvents: keepOpen ? "auto" : "none",
    border: "none",
    boxShadow: theme.boxShadow.DEFAULT,
    fontSize: theme.fontSize["2xs"],
    padding: `${theme.spacing[1.5]} ${theme.spacing[3]}`,
    maxWidth: theme.maxWidth.sm,
    ...deepMerge(getBackgroundColor(color, theme), getColor(color, theme), getBorderRadius(layoutTheme, theme)),
    "& > svg": {
        "& > path": {
            background: "red !important",
        },
    },
}));

export const Body = styled("div").withConfig({
    shouldForwardProp: createShouldForwardPropBlockList(["color"]),
})<BodyProps>(({ color, theme }) => ({
    position: "relative",
    "& + svg": {
        "& path": {
            ...deepMerge(getBodyFillColor(color, theme)),
        },
    },
}));

export const Arrow = styled("div")({
    zIndex: 100,
});
